// extracted by css-extract-rspack-plugin
export default {"print":"PrintComponent_print__WAuGh"};